import { MessageBus } from '@podium/browser';

let messageBus;

const lookupMessageBus = () => {
    if (!messageBus) {
        messageBus = new MessageBus();
    }
    return messageBus;
};

export const initialBannerPublishEvent = ({ pageType, page, city, country }) =>
    bannerPodletPublishEvent({
        type: 'page',
        action: 'loaded',
        pageType,
        page,
        city,
        country,
    });

export const filterBannerPublishEvent = ({ page, city, country, ...rest }) =>
    bannerPodletPublishEvent({
        ...rest,
        type: 'filter',
        action: 'updated',
        page,
        city,
        country,
    });

export const bannerPodletPublishEvent = ({ type, action, pageType, page, city, country, ...rest }) => {
    try {
        const data = {
            ...rest,
            pageType,
            side: page || 1,
            destination: {
                city,
                country,
            },
        };

        if (!pageType) {
            delete data.pageType;
        }

        lookupMessageBus().publish(type, action, data);
    } catch (e) {
        // Errors thrown here are out of our control, so we simply swallow them
        if (process.env.NODE_ENV !== 'production') {
            console.warn('Publishing message failed', e);
        }
    }
};
